import { FC } from 'react';
import PhoneInputWithCountrySelect from 'react-phone-number-input';
import 'react-phone-number-input/style.css'

type Props = {
  name: string;
  value: string;
  onChange: (phone: string | undefined) => void;
  placeholder?: string;
  error?: boolean;
  errorText?: string;
  country?: any;
  className?: string;
}

const Phone:FC<Props> = ({ name, value, onChange, placeholder = '', error = false, errorText = '', country, className = '' }) => {
  return (
    <div className="mb-4">
      <PhoneInputWithCountrySelect
        international
        defaultCountry={country}
        name={name}
        value={value}
        onChange={onChange}
        numberInputProps={{
          placeholder,
          style: {
            all: 'unset'
          }
        }}
        className={`
          outline-none
          w-full h-12
          bg-gray-200 rounded-2xl
          border ${error ? 'border-red-500 focus:border-red-500' : 'border-gray-300 focus:border-primary'}
          shadow-neu-inner
          text-black
          text-base
          px-4 py-3
          placeholder:text-gray-400 appearance-none
          ${className}
        `}
      />
      {error && errorText ? (
        <span className="block text-red-500 text-xs pl-4 pt-2">{errorText}</span>
      ) : null}
    </div>
  )
}

export default Phone;